var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label)+":")]):_vm._e(),_c('b-form-select',{attrs:{"options":_vm.options,"size":"sm"},on:{"input":function($event){return _vm.$emit('input', _vm.selected)}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }